import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
    "X-API-Key": token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllEmpolyees = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = `/admin/employees?page=${page}&size=${size}`;
  const response = await axios.post<any>(url, params, {
    headers: getHeader(),
  });
  return response.data;
};

export const clearBECache = async (apiKey?: string): Promise<any> => {
  let url = `/master-data-sync/cache/clear`;
  const token = apiKey || Cookies.get("token") || "";
  const response = await axios.post<any>(
    url,
    {},
    {
      headers: {
        ...getHeader(),
        "X-API-Key": token,
      },
    }
  );
  return response.data;
};


